import { createContext, useContext } from "react";
import type { MessagesCount } from "@certa/queries/queries/comments/getMessagesCount.query";

type FieldCommentsContextType = {
  commentsCounts: Record<string, MessagesCount>;
};

const FieldCommentsContext = createContext<FieldCommentsContextType | null>(
  null
);

export const FieldCommentsContextProvider = FieldCommentsContext.Provider;

export const useFieldCommentsContext = () => {
  const contextValue = useContext(FieldCommentsContext);
  if (!contextValue) {
    throw new Error(
      "useFieldCommentsContext must be used within FieldCommentsContextProvider"
    );
  }
  return contextValue;
};
